import { H1, VStack } from '@betterment/samba-react';
import { WorkflowLayout } from '@betterment/shared-components';
import { useNavigate, useParams } from 'react-router-dom';
import * as Yup from 'yup';

import { PurposeCreationIntent } from '../../../../graphql/schema';
import Footer from '../../../../Shared/components-v2/footer/Footer';
import { NameAndImageForm } from '../../NameAndImageForm';
import { nameAndImage } from '../../sharedSchemas';
import { useRetirementStep } from '../FlowConfig';

type FormValues = Yup.InferType<typeof nameAndImage>;

export const RetirementNameAndImageStep: React.FC = () => {
  const navigate = useNavigate();
  const { flowId } = useParams<{ flowId: string }>();

  const { commit } = useRetirementStep('nameAndImage');

  const handleSubmit = (formValues: FormValues) => {
    commit(formValues);
    void navigate(`/add_purpose/retirement/${flowId}/retirement_selection`);
  };

  return (
    <WorkflowLayout pageTitle={null}>
      <WorkflowLayout.Header workflowTitle="Choose a name and image for this goal" onClose={() => navigate('/')} />
      <WorkflowLayout.Content>
        <VStack css={{ gap: 'space.400' }}>
          <H1 css={{ textWrap: 'auto' }}>Choose a name and image for this goal.</H1>
          <NameAndImageForm handleSubmit={handleSubmit} intent={PurposeCreationIntent.Retirement} />
        </VStack>
      </WorkflowLayout.Content>
      <WorkflowLayout.Footer>
        <Footer />
      </WorkflowLayout.Footer>
    </WorkflowLayout>
  );
};
